/**
 * Income Tax Act mapping data + Fuse search index — both memoised module-side
 * so the cost of parsing 500 KB of JSON and constructing a 100+ -section Fuse
 * index is paid exactly once per session.
 */
import Fuse from 'fuse.js';
import type { MappingData, Section, Form } from './types';
// eslint-disable-next-line import/no-relative-parent-imports
import rawMapping from './data/mapping.json';

export const MAPPING_DATA = rawMapping as unknown as MappingData;

let _sectionFuse: Fuse<Section> | null = null;

export function getSectionFuse(): Fuse<Section> {
  if (!_sectionFuse) {
    _sectionFuse = new Fuse(MAPPING_DATA.sections, {
      keys: [
        { name: 'old_ref',                weight: 2   },
        { name: 'new_ref',                weight: 2   },
        { name: 'old_title',              weight: 1.5 },
        { name: 'new_title',              weight: 1.5 },
        { name: 'keywords',               weight: 1   },
        { name: 'plain_english_summary',  weight: 0.8 },
        { name: 'category',               weight: 0.5 },
      ],
      threshold:         0.35,
      includeScore:      true,
      ignoreLocation:    true,
      minMatchCharLength: 2,
    });
  }
  return _sectionFuse;
}

let _formFuse: Fuse<Form> | null = null;

export function getFormFuse(): Fuse<Form> {
  if (!_formFuse) {
    _formFuse = new Fuse(MAPPING_DATA.forms, {
      keys: [
        { name: 'old_form',           weight: 2   },
        { name: 'new_form',           weight: 2   },
        { name: 'old_purpose',        weight: 1.5 },
        { name: 'new_purpose',        weight: 1.5 },
        { name: 'keywords',           weight: 1   },
        { name: 'structural_changes', weight: 0.8 },
      ],
      threshold:         0.35,
      includeScore:      true,
      ignoreLocation:    true,
      minMatchCharLength: 2,
    });
  }
  return _formFuse;
}
